import { put, takeEvery, call, all } from 'redux-saga/effects'
import { isEqual, reduce } from 'lodash'
import { CHECKAUTH } from '../constants/ActionTypes'
import { ROUTES, WHITE_LIST_PAGE } from '../constants/Routing'
import { adminData, checkUserToken } from '../apis/auth'
import { store } from '../store'
import { setAdmin, setLogoutAdmin } from '../store/adminSlice'
import { setUser, setLogout } from '../store/userSlice'

function * errorCallback ({ adminMode, isLogin, loginPath }) {
  yield all([
    put(adminMode ? setLogoutAdmin() : setLogout())
  ])

  if (!isLogin) window.location.pathname = loginPath
}

export function * fetchCheckAuth (props) {
  const { pathname } = window?.location || {}
  const adminMode = pathname.includes(ROUTES.ADMIN_ROOT)
  const loginPath = adminMode ? ROUTES.ADMIN_LOGIN : ROUTES.CLIENT_LOGIN
  const isLogin = pathname === loginPath || pathname === `${loginPath}/`
  const { user, admin } = store.getState() || {}
  const language = adminMode ? admin.language : user.language

  try {
    const result = yield call(adminMode ? adminData : checkUserToken)
    if (result?.status === 200) {
      const { nowGroupUserFunctions, functions } = result.data || {}
      const n = { ...result.data, active: true }
      if (language) n.language = language

      const functionList = adminMode ? functions : nowGroupUserFunctions
      const homeRoute = functionList?.[0]?.link
      if (!homeRoute) {
        yield call(errorCallback, { adminMode, isLogin, loginPath })
        return true
      }

      const findDiff = function (result, value, key) {
        const v1 = value
        const v2 = adminMode ? admin[key] : user[key]
        return isEqual(v1, v2) ? result : result.concat(key)
      }
      const diff = reduce(n, findDiff, [])
      const noAccessToPath = !functionList?.some(i => i.link === pathname)
      const isWhiteListPage = WHITE_LIST_PAGE?.some(i => i === pathname)
      const isChangingBrand = diff?.includes('nowGroupUserFunctions' || 'nowBrand' || 'nowGroup')

      yield put({ type: CHECKAUTH.SUCCESS })
      if (diff?.length) yield put(adminMode ? setAdmin(n) : setUser(n))
      if (isLogin || (noAccessToPath && !isWhiteListPage && isChangingBrand)) window.location.pathname = homeRoute
    } else yield call(errorCallback, { adminMode, isLogin, loginPath })
  } catch (err) { console.log(err.response) }
}

function * mySaga () {
  yield takeEvery(CHECKAUTH.REQUEST, fetchCheckAuth)
}

export default mySaga
